

export const environment = {
    production: false,
    apiUrl: '__apiUrl__',
    signalRurl: '__signalRurl__',
    sourceName: 'SARAPLUS Dev',
    tokenCredentials: '__tokenCredentials__',
    sessionDecryptKey: '__sessionDecryptKey__',
    ignoreEncryption: true,
    azureFDID: '6b3c6079-782d-4ffa-95e7-6c0f459b0083',
    sessionTimeout: '__sessionTimeout__',
    sessionIdle: '__sessionIdle__',
    appVersion: '__appVersion__',
    googleAnalyticsToken: '__googleAnalyticsToken__',
    mixPanelToken: '__mixPanelToken__',
    sentryTokenUrl: '__sentryTokenUrl__',
    activeReportsLicense: '__activeReportsLicense__',
    preventOrderStepJump: '__preventOrderStepJump__',
    quantumMetricUrl: '__quantumMetricUrl__',
    featureFlags: '__featureFlags__',
    aad: {
        clientId: 'e7cb38d4-5918-4f23-86cd-7304974edd75',
        tenantId: 'ab95a12d-ee0a-4594-b3e5-b47785e1c928',
        authority: 'https://login.microsoftonline.com/organizations',
        scopes: ['api://e7cb38d4-5918-4f23-86cd-7304974edd75/access_as_user']
    }
}